module.exports = __webpack_public_path__ + "media/images/index/feature/top-aoj-d-03718ab6efeba9c904480b25b880b40c.png";